import { Component, inject, OnInit } from '@angular/core';
import { NgFor } from '@angular/common';
import {
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';
import { ApiService } from '../../services/api/api.service';
import { Company } from '../../interfaces/Company';
import { CompanyResponse } from '../../interfaces/CompanyResponse';
import { Brand } from '../../interfaces/Brand';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../common/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-m-create-brand',
    standalone: true,
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        RouterLink,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        TranslocoModule,
        NgFor,
    ],
    templateUrl: './m-create-brand.component.html',
    styleUrl: './m-create-brand.component.scss',
})
export class MCreateBrandComponent implements OnInit {
    // isToggled
    isToggled = false;

    // Form
    addBrandForm: FormGroup;

    // Show alert
    showAlert: boolean = false;

    // Array of companies
    companies: Company[] = [];

    readonly dialog = inject(MatDialog);

    constructor(
        private fb: FormBuilder,
        public themeService: CustomizerSettingsService,
        private apiService: ApiService,
        private router: Router
    ) {
        this.addBrandForm = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(300)]],
            domain: ['', [Validators.required, Validators.maxLength(300)]],
            companyId: ['', [Validators.required]],
        });
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    ngOnInit() {
        this.apiService
            .getCompanyPagination(0, 1000000, 'name', 'asc')
            .subscribe((response: CompanyResponse) => {
                this.companies.push(...response.companies);
            });
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    /**
     * On submit
     */
    onSubmit(): void {
        // Return if the form is invalid
        if (this.addBrandForm.invalid) {
            this.showAlert = false;
            return;
        }

        // Disable the form
        this.addBrandForm.disable();

        // Hide the alert
        this.showAlert = false;

        // Add Company
        let newBrand: Brand = { ...this.addBrandForm.value };
        this.apiService.addBrand(newBrand).subscribe({
            next: (value) => {
                console.info(value);
                // Re-enable the form
                this.addBrandForm.enable();

                // Show the alert
                this.showAlert = true;
            },
            error: (error) => {
                let errMsg: string = error;
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                    data: {
                        title: 'ERROR',
                        message: errMsg,
                    },
                });
                // Re-enable the form
                this.addBrandForm.enable();

                // Show the alert
                this.showAlert = true;
            },
            complete: () => {
                this.router.navigateByUrl('/masters/brands');
            },
        });
    }
}
